import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
} from "@mui/material";

const styles = {
  tableContainer: {
    maxHeight: 280,
    overflowY: "auto",
    overflowX: "auto",
    scrollbarWidth: "thin",
  },
  table: {
    fontSize: "0.75rem",
  },
  tableHeaderCell: {
    fontSize: "0.75rem",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    background: "white",
    zIndex: 3,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  stickyCell: {
    fontSize: "0.75rem",
    whiteSpace: "nowrap",
    position: "sticky",
    background: "white",
    verticalAlign: "top",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  messageCell: {
    fontSize: "0.75rem",
    wordBreak: "break-word",
    minWidth: 220,
    verticalAlign: "top",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  customScrollbar: `
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    ::-webkit-scrollbar-thumb {
      background: gray;
      border-radius: 4px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
  `,
};

export default function LogPopover({ logs, maxWidth = 500 }) {
  return (
    <Paper
      style={{
        maxWidth: maxWidth,
        minWidth: 300,
        maxHeight: 300,
        overflow: "hidden",
        padding: 8,
      }}
    >
      <TableContainer style={styles.tableContainer}>
        <Table size="small" stickyHeader style={styles.table}>
          <TableHead>
            <TableRow>
              <TableCell
                style={{ ...styles.tableHeaderCell, left: 0, minWidth: 80 }}
              >
                Datum
              </TableCell>
              <TableCell
                style={{ ...styles.tableHeaderCell, left: 80, minWidth: 100 }}
              >
                Användare
              </TableCell>
              <TableCell style={{ ...styles.tableHeaderCell, minWidth: 220 }}>
                Meddelande
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs?.map((log, index) => (
              <TableRow key={index}>
                <TableCell
                  style={{
                    ...styles.stickyCell,
                    left: 0,
                    minWidth: 80,
                  }}
                >
                  {log.CreateTime.split(" ")[0]}
                </TableCell>
                <TableCell
                  style={{
                    ...styles.stickyCell,
                    left: 80,
                    minWidth: 100,
                  }}
                >
                  {log.AppUserId}
                </TableCell>
                <TableCell style={styles.messageCell}>{log.Message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Custom scrollbar styling */}
      <style>{styles.customScrollbar}</style>
    </Paper>
  );
}
